module.exports = {"turism":"Tourism and Adventure"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EN-vers/menu/Turism.json
// module id = V1Tw
// module chunks = 0